import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from '../guards/auth.guard';
import { PermisosModulosComponent } from './permisos-modulos/permisos-modulos.component';
import { CambiocontrasenaComponent } from './Usuarios/cambiocontrasena/cambiocontrasena.component';
import { NuevousuarioComponent } from './Usuarios/nuevousuario/nuevousuario.component';
 import { CalificacionesReportComponent } from '../components/calificaciones-report/calificaciones-report.component';
import { PagosReportComponent } from '../components/pagos-report/pagos-report.component';
import { ListadeplantelesComponent } from './Catalogo/listadeplanteles/listadeplanteles.component';
import { ListadoderesguardanteComponent } from './Catalogo/listadoderesguardante/listadoderesguardante.component';
import { ListadodebecasComponent } from './Recursos-humanos/listadodebecas/listadodebecas.component';
import { ListadodelentesComponent } from './Recursos-humanos/listadodelentes/listadodelentes.component';
import { ListadodeaparatosortopedicosComponent } from './Recursos-humanos/listadodeaparatosortopedicos/listadodeaparatosortopedicos.component';
import { ListadodeviaticosComponent } from './Recursos-humanos/listadodeviaticos/listadodeviaticos.component';
import { ListadodereportesComponent } from './Recursos-humanos/listadodereportes/listadodereportes.component';
import { ListadodereportesbecasComponent } from './Reportes/listadodereportesbecas/listadodereportesbecas.component';
import { ListadodereporteslentesComponent } from './Reportes/listadodereporteslentes/listadodereporteslentes.component';
import { ListadodereportespersonalComponent } from './Reportes/listadodereportespersonal/listadodereportespersonal.component';
import { ListadxmlcontabilidadComponent } from './Contabilidad/listadxmlcontabilidad/listadxmlcontabilidad.component';
import { ListadxmlmaterialesComponent } from './Recursos-materiales/listadxmlmateriales/listadxmlmateriales.component';
import { ListadxmlfinancierosComponent } from './Recursos-financieros/listadxmlfinancieros/listadxmlfinancieros.component';
import { ReportescontabilidadComponent } from './Contabilidad/reportescontabilidad/reportescontabilidad.component';
import { ReportesdiotComponent } from './Recursos-financieros/reportesdiot/reportesdiot.component';

const routes: Routes = [
    { 
        path: 'dashboard', 
        component: PagesComponent,canActivate:[AuthGuard],
        children: [
            { path: '', component: DashboardComponent,canActivate:[AuthGuard] },
            {path: 'permisos-modulos',component:PermisosModulosComponent,canActivate:[AuthGuard]},
            { path: 'cambio/contrasena', component: CambiocontrasenaComponent,canActivate:[AuthGuard] },
            { path: 'registro/nuevousuario', component: NuevousuarioComponent ,canActivate:[AuthGuard]},
            {path:'GenerateReporteCalificaciones',component:CalificacionesReportComponent,canActivate:[AuthGuard]},
            {path:'pagosreporte',component:PagosReportComponent,canActivate:[AuthGuard]},
            { path: 'listadeplanteles', component: ListadeplantelesComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listaderesguardante', component: ListadoderesguardanteComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listadebecas', component: ListadodebecasComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listadelentes', component: ListadodelentesComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listadeaparatos', component: ListadodeaparatosortopedicosComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listadeviaticos', component: ListadodeviaticosComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listadereportes', component: ListadodereportesComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listadereporteslentes', component: ListadodereporteslentesComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listadereportesbecas', component: ListadodereportesbecasComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listadereportespersonal', component: ListadodereportespersonalComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listaxmlcontabilidadRH', component: ListadxmlcontabilidadComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listaxmlmateriales', component: ListadxmlmaterialesComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'listaxmlfinancieros', component: ListadxmlfinancierosComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'reportes', component: ReportescontabilidadComponent, canActivate: [AuthGuard] }, //planeacion
            { path: 'reportesdiot', component: ReportesdiotComponent, canActivate: [AuthGuard] }, //planeacion

        ]
    },
];

@NgModule({
    imports: [ RouterModule.forChild(routes) ],
    exports: [ RouterModule ]
})
export class PagesRoutingModule {}


